import { createContext, useContext, useState, useCallback } from 'react'
import { translations } from '../i18n/translations'

const I18nContext = createContext(null)

const STORAGE_KEY = 'portal_language'

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || 'en'
  })

  const changeLocale = useCallback((newLocale) => {
    if (translations[newLocale]) {
      setLocale(newLocale)
      localStorage.setItem(STORAGE_KEY, newLocale)
      document.documentElement.lang = newLocale
    }
  }, [])

  const t = useCallback((key, params = {}) => {
    let text = translations[locale]?.[key] || translations.en?.[key] || key

    // Simple parameter interpolation: t('key', { name: 'John' }) → replaces {name}
    for (const [param, value] of Object.entries(params)) {
      text = text.replace(new RegExp(`\\{${param}\\}`, 'g'), value)
    }

    return text
  }, [locale])

  const value = {
    locale,
    changeLocale,
    t,
    availableLocales: [
      { code: 'en', label: 'English' },
      { code: 'fil', label: 'Filipino' }
    ]
  }

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  )
}

export function useI18n() {
  const context = useContext(I18nContext)
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider')
  }
  return context
}

export default useI18n
